import React from 'react';
import cn from 'classnames';

import { publishedTutorial, youtubeWatchUrl } from 'components/SitePages/Tutorials/tutorials';

import styles from './styles.module.scss';

const playIcon = new URL('../../../img/main-page/play.svg', import.meta.url).href;

interface TutorialHintProps {
  /** id ролика из TUTORIALS, например registration */
  tutorialId: string;
  /** Текст подсказки, обычно из переводов */
  text: string;
  className?: string;
}

/**
 * Ссылка «посмотрите ролик» рядом с формой. Если ролик ещё не опубликован
 * (в TUTORIALS нет youtubeId), подсказка не рисуется — битой ссылки не будет.
 *
 * Открываем YouTube в новой вкладке специально: переход на /tutorials закрыл бы
 * попап регистрации вместе с уже введёнными данными.
 */
const TutorialHint: React.FC<TutorialHintProps> = ({ tutorialId, text, className }) => {
  const tutorial = publishedTutorial(tutorialId);

  if (!tutorial?.youtubeId) {
    return null;
  }

  return (
    <a
      className={cn(styles.hint, className)}
      href={youtubeWatchUrl(tutorial.youtubeId)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={styles.play}>
        <img src={playIcon} alt="" className={styles.playIcon} />
      </span>
      <span className={styles.text}>
        {text}
        {tutorial.duration && <span className={styles.duration}>{tutorial.duration}</span>}
      </span>
    </a>
  );
};

export default TutorialHint;
